<template>
  <div class="modal__header--angles">
    <div class="modal__header-section" v-if="header">
      <div class="modal__header-title" v-if="header.title">{{ header.title }}</div>
      <div class="modal__header-description" v-html="header.description"></div>
    </div>
    <div class="modal__close-btn">
      <i class="fa fa-times" @click="closeModal"></i>
    </div>
    <div class="btn-group modal__nav" role="group" aria-label="...">
      <button type="button" class="btn btn-default modal__nav-button modal__nav-button--back" @click.stop="prevItem" :disabled="isFirst">
        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
      </button>
      <button type="button" class="btn btn-default modal__nav-button modal__nav-button--forward" @click.stop="nextItem" :disabled="isLast">
        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HeaderItem',
    components: {
    },
    props: ['header', 'isLast', 'isFirst'],
    methods: {
      closeModal() {
        this.$store.dispatch('meetingAgendas/closeModal');
      },
      nextItem() {
        this.$store.dispatch('meetingAgendas/nextItem');
      },
      prevItem() {
        this.$store.dispatch('meetingAgendas/prevItem');
      },
    },
  };
</script>

